// ---------------------------------------------------------------------------
// CONFIG — the ONLY place to edit LinkedIn feed posts.
// Paste the post URL (any form: /feed/update/urn:..., /posts/...-activity-...,
// or an /embed/... URL). The carousel builds the iframe from it.
// Newest first — the carousel shows them in array order.
// ---------------------------------------------------------------------------
export const LINKEDIN_POST_URLS = [
  "https://www.linkedin.com/feed/update/urn:li:activity:7455813251134541824",
  "https://www.linkedin.com/feed/update/urn:li:share:7457553543810404352",
  "https://www.linkedin.com/feed/update/urn:li:share:7464796861120360448",
  "https://www.linkedin.com/feed/update/urn:li:share:7445593895012540417",
  "https://www.linkedin.com/feed/update/urn:li:share:7442540858312384513",
  "https://www.linkedin.com/feed/update/urn:li:share:7441770740598870016",
  "https://www.linkedin.com/feed/update/urn:li:share:7440993158848667648",
  "https://www.linkedin.com/feed/update/urn:li:share:7440615631810445312",
  "https://www.linkedin.com/feed/update/urn:li:share:7429729016451915776",
  "https://www.linkedin.com/feed/update/urn:li:ugcPost:7439520959616892928",
  "https://www.linkedin.com/feed/update/urn:li:share:7459154151864811521",
  "https://www.linkedin.com/feed/update/urn:li:share:7463887530422087680",
  "https://www.linkedin.com/feed/update/urn:li:share:7464793675433140226",
] as const;

/** Feed is intentionally short — only the most recent/best posts are shown. */
export const MAX_POSTS = 4;

// ---------------------------------------------------------------------------
// HOMEPAGE "Latest from LinkedIn" — native cards (no iframe, no feed script).
// Edit ONE entry to replace a featured post. Maximum 3 are shown.
// A card only renders when title, summary, date, image and linkedinUrl are
// all filled in — incomplete entries stay hidden (never publish placeholders).
//   image: public path of an approved local copy, e.g.
//          "/images/linkedin/post-cover.jpg" (do not hotlink LinkedIn media)
//   date:  ISO date "YYYY-MM-DD"
//   internalUrl: optional related page on arifkhanglobal.com, e.g. "/ask-arif/..."
// ---------------------------------------------------------------------------
export type FeaturedLinkedInPost = {
  category: string;
  title: string;
  summary: string;
  date: string;
  image: string;
  imageAlt?: string;
  linkedinUrl: string;
  internalUrl?: string;
};

export const FEATURED_LINKEDIN_POSTS: FeaturedLinkedInPost[] = [
  {
    category: "",
    title: "",
    summary: "",
    date: "",
    image: "",
    linkedinUrl: LINKEDIN_POST_URLS[0],
  },
  {
    category: "",
    title: "",
    summary: "",
    date: "",
    image: "",
    linkedinUrl: LINKEDIN_POST_URLS[1],
  },
  {
    category: "",
    title: "",
    summary: "",
    date: "",
    image: "",
    linkedinUrl: LINKEDIN_POST_URLS[2],
  },
];

export function completeFeaturedPosts(): FeaturedLinkedInPost[] {
  return FEATURED_LINKEDIN_POSTS.filter(
    (p) => p.title && p.summary && p.date && p.image && p.linkedinUrl,
  ).slice(0, 3);
}
